module.exports = __webpack_public_path__ + "static/media/OfficinaSansITCPro-Bold.af831d19.ttf";